import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const teamCollection = collection(db, "teams");

const teamService = { 
  getAll: async () => {
    try {  
      const teamSnapshot = await getDocs(teamCollection);
      const teamList = teamSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return teamList;
    } catch (error) {
      console.error('Error fetching team:', error);
      throw error;
    }
  },
  add: async (teamData) => {
    try {
      const docRef = await addDoc(teamCollection, teamData);
      return docRef;
    } catch (error) {
      console.error('Error adding team:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const teamRef = doc(db, 'teams', id);
      await updateDoc(teamRef, data);
    } catch (error) {
      console.error('Error updating team:', error);
      throw error;
    }
  },
  delete: async (teamId) => {
    try {
     await deleteDoc(doc(db, "teams", teamId));
     return true;
    } catch (error) {
      console.error('Error deleting team:', error);
      throw error;
    }
  },

    getIdByName: async (teamName) => {
        try {
        const teamSnapshot = await getDocs(teamCollection);
        const teamList = teamSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        })); 
    
        // Remove spaces for comparison
        const formattedTeamName = teamName.trim().toLowerCase().replace(/\s+/g, '');
        
        const team = teamList.find((team) =>
            team.name.toLowerCase().replace(/\s+/g, '') === formattedTeamName
        );
    
        return team ? team.id : null;
        } 
        catch (error) {
        console.error('Error fetching team:', error);
        throw error; 
        }
    },
  

  getNameById: async (teamId) => {
    if (!teamId) return null; // prevent teamId is null/undefined
    try {
      const teamRef = doc(db, 'teams', teamId);
      const teamSnap = await getDoc(teamRef);

      if (teamSnap.exists()) {
        return teamSnap.data().name;

      }else {
        return null; 
      }
    } 
    catch (error) {
      console.error('Error getting team name:', error);
      throw error; 
    }
  },

  getDivisionTeams: async (divisionId) => {
    try {
        const querySnapshot = await getDocs(
          query(teamCollection, where("division_id", "==", divisionId))
        );
        
        const divisionTeams = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        
    
        return divisionTeams;
    } 
    catch (error) {
        console.error('Error fetching teams:', error);
        throw error;
    }
}



};

export default teamService;

